
import type { SearchResult } from '../search/interfaces';
import type { ApiCommand, ApiRequest } from './apiCommand';
import { getEmbed } from '../client/hal';
import { applyItemQueryParameterDefaults } from './defaultQueryParameters';
import type { SearchCategoryCount } from '../dto/searchModels';
import { assumeArrayOfObject } from '../type-guards/assumeType';

export class SearchCommand implements ApiCommand<SearchResult> {
  constructor(private input: { queryParams: Record<string, string> }) {
  }
  request(): ApiRequest {
    return {
      linkName: 'search',
      pathParams: {},
      queryParams: applyItemQueryParameterDefaults(this.input.queryParams),
      method: 'GET',
      body: null
    };
  }
  asOutput(body: unknown): SearchResult {
    /*
      TODO: Don't do this ugly inplace mutation
    */
    const result: any = body;
    result.hits = getEmbed(result, 'collection', []);
    result._embedded = undefined;
    return result;
  }
}

export class GetSearchCategoryCountsCommand implements ApiCommand<SearchCategoryCount[]> {
  constructor(input: Record<string, never>) {
    void input;
  }
  request(): ApiRequest {
    return {
      linkName: 'search',
      pathParams: {},
      queryParams: applyItemQueryParameterDefaults({ typeCount: 'true' }),
      method: 'GET',
      body: null
    };
  }
  asOutput(body: unknown): SearchCategoryCount[] {
    return assumeArrayOfObject(body, 'doc_count');
  }
}

